import n from "styled-components";
var e = function() {
  return ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`;
}, a = /* @__PURE__ */ n.h1.withConfig({
  displayName: "hTag",
  componentId: "tvm2hz-0"
})(["", ""], e());
export {
  a as hTag
};
